import { render, staticRenderFns } from "./MerchantProduct.vue?vue&type=template&id=0b8050b6&scoped=true&"
import script from "./MerchantProduct.vue?vue&type=script&lang=js&"
export * from "./MerchantProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8050b6",
  null
  
)

export default component.exports